exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.context-help-header {\n  cursor: pointer;\n  opacity: 0.7;\n  width: 28px;\n  height: 28px;\n  margin: 0px;\n}\n.context-help-header:hover {\n    opacity: 1.0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-495033fa","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/misc/context-header/ContextHeader.vue
// module id = 669
// module chunks = 1